const SERVICE_CLASS_TYPES = {
    'class_any': 'a',
    'class_eco': 'e',
    'class_bis': 'b',
};

export class ServiceClass {
    constructor({ searchModule }) {
        this.$searchModule = searchModule;

        this._selectedClass = SERVICE_CLASS_TYPES[$('input[name="flight_class"]:checked').val()];//   SERVICE_CLASS_TYPES.class_any;

        this.$flightClass = this.$searchModule.find('.flight_class');

        this._init();
    }

    _init() {
        this.$flightClass.find('input[name="flight_class"]').change((event) => {
            const selectedValue = $('input[name="flight_class"]:checked').val();

            this._selectedClass = SERVICE_CLASS_TYPES[selectedValue];
        });
    }

    getServiceClass() {
        return this._selectedClass;
    }
}